export default "__VITE_ASSET__BIvyfHAi__"